import { render, staticRenderFns } from "./PreviewCard.vue?vue&type=template&id=51fcdddc&scoped=true&"
import script from "./PreviewCard.vue?vue&type=script&lang=js&"
export * from "./PreviewCard.vue?vue&type=script&lang=js&"
import style0 from "./PreviewCard.vue?vue&type=style&index=0&id=51fcdddc&prod&lang=scss&"
import style1 from "./PreviewCard.vue?vue&type=style&index=1&id=51fcdddc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51fcdddc",
  null
  
)

export default component.exports